<template>
  <article class="modal_password">
    <section class="modal_password__modal">
      <div class="modal_password__modal__info">
        <h5 style="margin-bottom:10px;">Importar programación mensual</h5>
        <p style="margin-bottom:10px;">Seleccione el periodo mensual que desea importar:</p>
        <input id="fecha" @input="errorMessage=''" v-model="fecha" type="month">
        <h5  class="login__sect-right__form--error" style="font-size: 13px; font-family: Inter UI Regular">{{errorMessage}}</h5>
      </div>
      <div class="modal_password__modal__buttons">
        <button @click="onActivateModal" class="modal_password__modal__buttons--left">
          IMPORTAR
        </button>
        <button @click="onCancelModal" class="modal_password__modal__buttons--right">
          CANCELAR
        </button>
      </div>
    </section>
  </article>
</template>

<script>
import moment from 'moment'
export default {
  data(){
    return{
      fecha:"",
      errorMessage:"",
      
    }
  },
  methods:{
    onCancelModal(event){
      this.$emit('cancel', false);
    },
    onActivateModal(event){
      if (this.fecha){
        this.$emit('import', this.fecha)
      }else{
        this.errorMessage="No ha seleccionado una fecha"
      }
      
    }
  },
  mounted(){
    document.getElementById("fecha").value= moment().format('YYYY-MM');
    this.fecha= moment().format('YYYY-MM');
  }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/ModalImport.vue